import { Backdrop, Button, Grid, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import useFetchAllPendidikanSelection from "../../api/effects/queries/RiwayatPendidikan/useFetchAllPendidikanSelection";
import InputDate from "../../components/InputDate";
import InputRadio from "../../components/InputRadio";
import InputSelect from "../../components/InputSelect";
import InputTextField from "../../components/InputTextField";
import { WarningModal } from "../../components/WarningModal";
import { PendidikanSelectionResponse } from "../../models/Pendidikan";
import { AddRiwayatPendidikanPayload } from "../../models/RiwayatPendidikan";
import { toIsoStringDate } from "../../utils/dateConvert";
import { useForm, Controller } from "react-hook-form";
import RadioButton from "./RadioButton";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "90%",
  maxWidth: "900px",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));

const FullButton = styled(Button)(({ theme }) => ({
  width: "70%",
}));

const ScrollGrid = styled(Grid)(({ theme }) => ({
  overflow: "auto",
  maxHeight: "90vh",
}));

type Props = {
  open: boolean;
  value: AddRiwayatPendidikanPayload;
  handleClose: () => void;
  handleEdit: (e: any) => void;
};

export default function PendidikanTerakhirModal({
  value,
  open,
  handleClose,
  handleEdit,
}: Props) {
  const [pendidikan, setPendidikan] = useState(value.PENDIDIKAN_ID);
  const [namaInstitusi, setNamaInstitusi] = useState(value.NAMA_INSTITUSI);
  const [kota, setKota] = useState(value.KOTA);
  const [jurusan, setJurusan] = useState(value.JURUSAN);
  const [tahunMulai, setTahunMulai] = useState(value.TAHUN_MULAI);
  const [tahunSelesai, setTahunSelesai] = useState(value.TAHUN_SELESAI);
  const [pembiayaan, setPembiayaan] = useState(value.PEMBIAYAAN);
  const [lulus, setLulus] = useState(value.LULUS);

  const { data: PendidikanData } = useFetchAllPendidikanSelection();

  const [selectionData, setSelectionData] = useState<
    PendidikanSelectionResponse[]
  >([]);

  useEffect(() => {
    if (PendidikanData !== undefined) {
      setSelectionData(PendidikanData);
    }
  }, [PendidikanData]);

  const handlePendidikan = (e: any) => {
    setPendidikan(e.target.value);
  };
  const handleNamaInsitutsi = (e: any) => {
    setNamaInstitusi(e.target.value);
  };
  const handleKota = (e: any) => {
    setKota(e.target.value);
  };
  const handleJurusan = (e: any) => {
    setJurusan(e.target.value);
  };
  const handleTahunMulai = (e: any) => {
    setTahunMulai(e);
  };
  const handleTahunSelesai = (e: any) => {
    setTahunSelesai(e);
  };
  const handlePembiyaan = (e: any) => {
    setPembiayaan(e.target.value);
  };
  const handleLulus = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLulus(e.target.value === "true");
  };

  const [warningModalState, setWarningModalState] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");

  const handleSave = () => {
    if (
      pendidikan === "" ||
      namaInstitusi === "" ||
      kota === "" ||
      jurusan === "" ||
      tahunMulai === "" ||
      tahunSelesai === "" ||
      pembiayaan === ""
    ) {
      setWarningMessage("Mohon Untuk Lengkapi Pendidikan Terakhir");
      setWarningModalState(true);
      return
    }
    const tanggalMulai = new Date(tahunMulai);
    const tanggalSelesai = new Date(tahunSelesai);
    if (tanggalSelesai && tanggalSelesai < tanggalMulai) {
      setWarningMessage("Tanggal Selesai Tidak Boleh Sebelum Tanggal Mulai.");
      setWarningModalState(true);
      return;
    }
    handleEdit({
      PENDIDIKAN_ID: pendidikan,
      NAMA_INSTITUSI: namaInstitusi,
      KOTA: kota,
      JURUSAN: jurusan,
      TAHUN_MULAI: toIsoStringDate(tahunMulai),
      TAHUN_SELESAI: toIsoStringDate(tahunSelesai),
      PEMBIAYAAN: pembiayaan,
      LULUS: lulus,
    });
    handleClose();

  };

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <WarningModal
        open={warningModalState}
        handleClose={() => {
          setWarningModalState(false);
        }}
        text={warningMessage}
      />
      <SquareGrid container>
        <ScrollGrid container>
          <Grid container justifyContent="flex-start" paddingLeft={"10.5%"} item xs={6}
            paddingBottom={
              {
                xs: 5,
                sm: 5,
                md: 5,
                lg: 5,
                xl: 5
              }}>
            <Typography variant="subtitle1" color="black">
              Pendidikan Terakhir
            </Typography>
          </Grid>
          <Grid container justifyContent="flex-end" item xs={6}>
            <Button onClick={handleClose}>Close</Button>
          </Grid>
          <InputTextField
            title={"Institusi"}
            value={namaInstitusi}
            handleEdit={handleNamaInsitutsi}
          />
          <InputTextField title={"Kota"} value={kota} handleEdit={handleKota} />
          <InputSelect
            title={"Pendidikan"}
            value={pendidikan}
            selection={selectionData}
            handleEdit={handlePendidikan}
          />
          <InputTextField
            title={"Jurusan"}
            value={jurusan}
            handleEdit={handleJurusan}
          />
          <InputDate
            title={"Tanggal Mulai"}
            value={tahunMulai}
            handleEdit={handleTahunMulai}
          />
          <InputDate
            title={"Tanggal Selesai"}
            value={tahunSelesai}
            handleEdit={handleTahunSelesai}
          />
          <InputTextField
            title={"Pembiayaan"}
            value={pembiayaan}
            handleEdit={handlePembiyaan}
          />
          <RadioButton
            title="Lulus"
            value={lulus ? "true" : "false"}
            onChange={handleLulus}
          />
          <Grid container justifyContent="center" item lg={12}
            sx={{ mt: 3 }}
            paddingTop={{
              xs: 2,
              sm: 2,
              md: 2,
              lg: 2,
              xl: 2
            }}
            paddingBottom={{
              xs: 2,
              sm: 2,
              md: 2,
              lg: 2,
              xl: 2
            }}>
            <FullButton variant="contained" onClick={handleSave}>
              Save
            </FullButton>
          </Grid>
        </ScrollGrid>
      </SquareGrid>
    </Backdrop>
  );
}
